export default {
  //设置用户信息
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setToken(state, data) {
    state.token = data
  },
  setCode(state, data) {
    state.code = data
  },
  setSign(state){
    state.userInfo.is_sign = 1;
  }
}



// WEBPACK FOOTER //
// ./src/store/user/mutations.js